import { Id } from '../types'

import { PaywallError } from './PaywallError'

export class InvalidPropsError extends PaywallError {
  constructor(id: Id) {
    super(`Invalid props in block ${id}`)
  }
}
